import { TERMINE_TERMIN_CREATE } from '@/domain/termine/hooks/graphql/mutation';
import { FormValues } from '@/domain/termine/shared/types/CreateTermineInput';
import { toGraphQLMarkierung } from '@/domain/termine/shared/types/Markierung';
import {
  TerminWiederholung,
  wiederholungToGraphQLMap,
} from '@/domain/termine/shared/types/TerminWiederholung';
import {
  CreateTerminMutation,
  CreateTerminMutationVariables,
  Termine_TerminCreateInput,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';

type CreateTerminProps = {
  managerId: string;
  termin: FormValues;
};

export function useCreateTermine() {
  const [mutate, { data, loading }] = useMutation<
    CreateTerminMutation,
    CreateTerminMutationVariables
  >(TERMINE_TERMIN_CREATE, {
    refetchQueries: ['GetTagesDaten'],
    awaitRefetchQueries: true,
  });

  const createTermin = async (props: CreateTerminProps) => {
    let terminInput: Termine_TerminCreateInput = {
      datum: props.termin.datum,
      titel: props.termin.titel,
      beschreibung: props.termin.beschreibung,
      specials: props.termin.specials,
      standortId: props.termin.standortId,
      markierung: toGraphQLMarkierung(props.termin.markierung),
      wiederholung:
        wiederholungToGraphQLMap[
          props.termin.wiederholung ?? TerminWiederholung.OHNE
        ],
      beginn: props.termin.beginn,
      ende: props.termin.ende,
      wiederholungBis: props.termin.wiederholungBis,
      terminImage: props.termin.terminBildInput,
    };

    if (
      props.termin.terminKalenderId &&
      props.termin.terminKalenderId !== 'NO_KALENDER'
    ) {
      terminInput = {
        ...terminInput,
        terminKalenderId: props.termin.terminKalenderId,
      };
    }
    const result = await mutate({
      variables: {
        managerId: props.managerId,
        termin: terminInput,
      },
    });
    return result.data?.termine_terminCreate;
  };

  return {
    createTermin,
    response: data?.termine_terminCreate,
    loading,
  };
}
